import { useRef } from "react";

export default function ProgressRing({
  progress,
  avatarSize,
  strokeWidth = 6,
}: {
  progress: number;
  avatarSize: number;
  strokeWidth?: number;
}) {
  const stroke = strokeWidth;
  const outerRadius = avatarSize / 2 + stroke;

  // round and supbstract 1px to avoid anti-aliasing artifacts
  const normalizedRadius = Math.floor(outerRadius - stroke / 2) - 1;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  // Prevent animation when size changes and show animation only after initial render
  const lastSize = useRef(avatarSize);
  const showAnimation = lastSize.current === avatarSize;
  lastSize.current = avatarSize;

  return (
    <svg
      style={{
        position: "absolute",
        left: -stroke,
        top: -stroke,
        pointerEvents: "none",
        zIndex: "var(--pyne-layer-avatar-progress-ring)",
      }}
      width={outerRadius * 2}
      height={outerRadius * 2}
    >
      {/* progress bar background */}
      <circle
        stroke="var(--pyne-primary-bg)"
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={circumference + " " + circumference}
        r={normalizedRadius}
        cx={outerRadius}
        cy={outerRadius}
      />
      {/* progress bar */}
      <circle
        stroke="var(--pyne-primary)"
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={circumference + " " + circumference}
        style={{
          strokeDashoffset,
          transform: "rotate(-90deg)",
          transformOrigin: "50% 50%",
          transition: showAnimation ? `stroke-dashoffset 0.35s` : undefined,
        }}
        r={normalizedRadius}
        cx={outerRadius}
        cy={outerRadius}
      />
    </svg>
  );
}
